import type { ValidComponent } from 'solid-js'
import { createMemo } from 'solid-js'
import { Dynamic } from 'solid-js/web'
import { twMerge } from 'tailwind-merge'
import type { ListSubheaderPropsType } from '~/types/ListSubheader'

export default function ListSubheader(props: ListSubheaderPropsType) {
  const Component = props.component || 'div'

  const subheaderClasses = createMemo(() => {
    const colorClasses = {
      default: 'text-foreground-muted',
      primary: 'text-primary',
      inherit: 'text-inherit'
    }

    return twMerge(
      'px-4 py-3 text-xs font-semibold uppercase tracking-wider leading-4',
      'select-none',

      !props.disableSticky && 'sticky top-0 bg-surface/80 dark:bg-slate-800/80 backdrop-blur-sm z-10',
      props.inset && 'pl-14',
      colorClasses[props.color || 'default'],
      props.class
    )
  })

  return (
    <Dynamic component={Component as ValidComponent} class={subheaderClasses()} classList={props.classList} role="presentation">
      {props.children}
    </Dynamic>
  )
}
